import * as React from "react";
import { WrappedFieldProps } from "redux-form";
import "react-dates/initialize";
import { SingleDatePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import * as moment from "moment";

type Props = {
  label: string;
  type: string;
  max?: number;
  min?: number;
  disabled: boolean;
  startDateLabel: string;
  endDateLabel: string;
  wrapperClassName?: string;
  placeholder?: string;
};

type State = {
  focusedInput: any;
  checked: any;
};

class DatePickerField extends React.PureComponent<WrappedFieldProps & Props, State> {
  constructor(props: WrappedFieldProps & Props) {
    super(props);
    this.state = {
      focusedInput: null,
      checked: false,
    };
    this.handleFocusChange = this.handleFocusChange.bind(this);
  }
  public handleFocusChange(focusedInput) {
    this.setState({ focusedInput });
  }

  public handleCheckboxChange = (event) => {
    this.setState({ checked: event.target.checked });
    this.props.input.onChange(moment().format());
  };

  public render() {
    const { input, disabled, wrapperClassName, placeholder } = this.props;
    const { meta, label } = this.props;
    let formClasses: string = "form_field form_field--select ";
    formClasses += meta.error && meta.touched ? " form_field--has_error" : "";
    formClasses += wrapperClassName ? ` ${wrapperClassName} ` : "";
    formClasses += disabled ? " form_field--disabled" : "";
    const { focusedInput, checked } = this.state;
    const Today = new Date();
    // const value = input && input.value ? moment(input.value) : null;
    const value = checked ? moment(Today) : input && input.value ? moment(input.value) : null;

    const blockOutsideRange = (day) => {
      const today = new Date();
      const afterTomorrow = new Date(today);
      afterTomorrow.setDate(afterTomorrow.getDate() + 2);
      if (moment(day._d) > moment(afterTomorrow)) {
        return false;
      } else {
        return true;
      }
    };
    const SendSms = (day) => {
      const today = new Date();
      if (moment(day._d) > moment(today)) {
        return false;
      } else {
        return true;
      }
    };
    return (
      <div className={formClasses}>
        <label htmlFor={input.name}>{label}</label>
        <div className='DatePickerField'>
          <SingleDatePicker
            id={input.name}
            isOutsideRange={
              (day) => (input.name == "date_send_of_sms" ? SendSms(day) : null || input.name !== "contactDate" ? blockOutsideRange(day) : false)
              // input.name == "date_send_of_sms" && SendSms(day)
            }
            focused={focusedInput}
            onDateChange={(date) => {
              const tempDate = date.clone();
              tempDate.set("hour", 0);
              tempDate.set("minute", 0);
              // if(value) {
              //     tempDate.hour(value.get('hour'))
              //     tempDate.minute(value.get('minute'))
              // }
              input.onChange(tempDate.format());
            }}
            onFocusChange={(focusedObj) => {
              this.handleFocusChange(focusedObj.focused);
            }}
            date={value}
            readOnly={true}
            noBorder={true}
            block={false}
            displayFormat='DD-MM-YYYY'
            placeholder={placeholder}
            // isOutsideRange={day => moment().diff(day) < 0}
          />
          {input.name === "date_send_of_sms" && (
            <>
              <label className='checkbox__wrapper'>
                <input className='checkbox--input' type='checkbox' checked={this.state.checked} onChange={this.handleCheckboxChange} />
                <p>Wyślij teraz</p>
              </label>
            </>
          )}
          {(meta.touched && meta.error && (
            <div className='form_field--error_wrapper'>
              <span className='form_field--error'>{meta.error}</span>
            </div>
          )) ||
            (meta.warning && <span>{meta.warning}</span>)}
        </div>
      </div>
    );
  }
}

export default DatePickerField;



// WEBPACK FOOTER //
// ./src/components/Forms/Fields/DatePicker.tsx